<template>
  <div class="row">
    <div class="mx-auto col-md-12">
      <div class="card p-3 mb-3">
        <div class="card-body">
          <b-card class="mb-3" header="Parâmetro Data de Pagamento">
            <b-card no-body>
              <b-card-header size="sm">
                <div class="float-right">
                  <b-button
                    v-if="btnNovoRegistro"
                    variant="outline-secondary"
                    @click.prevent="incluir"
                    title=" Novo Parâmetro"
                  >
                    <font-awesome-icon
                      :icon="['far', 'plus-square']"
                      title=" Novo Parâmetro"
                      class="mr-1"
                    />
                    Novo Parâmetro
                  </b-button>
                </div>
              </b-card-header>

              <b-table
                no-provider-paging
                small
                responsive
                :current-page="tabela.currentPage"
                :empty-text="tabela.emptyText"
                :fields="tabela.fields"
                :items="tabela.items"
                :per-page="tabela.perPage"
                :show-empty="tabela.showEmpty"
                :striped="tabela.striped"
              >
                <template v-slot:cell(data_pagamento)="data">
                  {{ $helpers.formatDateHourToDate(data.value) }}
                </template>
                <template v-slot:cell(editar)="data">
                  <b-link
                    v-if="habilitarEdicao(data.item)"
                    class="text-primary"
                    style="font-size: 18px"
                    @click.prevent="editar(data.item)"
                    title="Editar"
                  >
                    <font-awesome-icon :icon="['fas', 'edit']" title="Editar" />
                  </b-link>
                </template>
              </b-table>
              <b-card-footer size="sm">
                <div class="float-left">
                  <b-input-group prepend="Quantidade de Registros">
                    <b-input disabled :value="tabela.items.length"></b-input>
                  </b-input-group>
                </div>
                <div class="float-right">
                  <b-pagination
                    align="right"
                    :total-rows="tabela.totalRows"
                    v-model="tabela.currentPage"
                    :per-page="tabela.perPage"
                  >
                  </b-pagination>
                </div>
              </b-card-footer>
            </b-card>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParametrosPagamento from "../../../models/ParametrosPagamento";
import moment from "moment";
export default {
  data() {
    return {
      mesAtual: moment(this.hoje).format("YYYY-MM"),
      btnNovoRegistro: true,
      tabela: {
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "mes",
            label: "Mês",
            class: "text-center",
          },
          {
            key: "ano",
            label: "Ano",
            class: "text-center",
          },
          {
            key: "data_pagamento",
            label: "Data Pagamento",
            class: "text-center",
          },
          {
            key: "editar",
            label: "",
            class: "text-center",
          },
        ],
        showEmpty: true,
        emptyText: "Nenhum registro encontrado",
        striped: true,
        perPage: 12,
        totalRows: 0,
      },
    };
  },

  methods: {
    
    habilitarEdicao(item) {
      let mesAnoDataPagamento = moment(item.data_pagamento).format("YYYY-MM");
        if(this.mesAtual >  mesAnoDataPagamento){
          return false;
        }else {
          return true;
        }
    },

    listar() {
      this.$api
        .get(`parametros-pagamento`)
        .then((response) => {
          if (response.status == 200) {
            this.tabela.items = [];
            response.data.dados.forEach((element) => {
              let parametro = new ParametrosPagamento(element);
              this.tabela.totalRows = response.data.dados.length;
              this.tabela.items.push(parametro);
            });
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    incluir() {
      this.$router.push({
        name: "parametrosPagamentoform",
        params: { id: "new" },
      });
    },

    editar(parametro) {
      this.$router.push({
        name: "parametrosPagamentoform",
        params: { id: parametro.id },
      });
    },
  },

  mounted() {
    this.listar();
  },
};
</script>

<style scoped>
</style>
